export const pillars = ['Arrests', 'Crime Scenes', 'Use of Force', 'Search Warrants', 'Crisis Response', 'Intelligence'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Field Operations (The End-of-Shift Blueprint)',
  desc: 'Generate flawless narratives for felony arrests, high-speed pursuits, and traffic incidents. Clear the call and get back to patrol in minutes.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Crime Scene & Evidence (The Investigation Pack)',
  desc: 'Master forensic descriptions for ocular inspections, narcotics seizures, and evidence recovery. Never doubt your chain of custody again.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Legal Safeguards (The Court-Ready Shield)',
  desc: 'An organized framework for Search Warrants, Exigent Circumstances, and Miranda Rights. Built to survive the toughest cross-examination.'
}, {
  n: 4,
  emoji: '📓',
  title: 'Tactical Intelligence (The Prevention Engine)',
  desc: 'Dominate shift briefings, hotspot analysis, and community safety strategies. Turn street data into actionable command reports.'
}, {
  n: 5,
  emoji: '📗',
  title: 'High-Tension Response (The Crisis Fortress)',
  desc: 'Manage Use of Force narratives, Crisis Negotiations, and Victim Assistance. Ensure your physical intervention is legally justified.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Admin Efficiency (The Career Command)',
  desc: 'Internal memos, performance reviews, and DA communications. Optimize every office task that keeps you away from the action.'
}];
export const volumeIncludes = ['Step-by-step Copy & Paste Prompts', 'Fill-in-the-blank brackets for fast customization', 'Legal terminology glossary', '"Court-Ready" verification checklists'];
export const bonuses = [{
  n: '01',
  title: 'The BWC Audio-to-Report Blueprint™',
  desc: 'Automate your Body-Cam transcriptions into professional narratives.',
  price: '$35',
  cover: 'https://cdn.magicpatterns.com/uploads/aYRrR4JnLotQdFRX9ZnCsi/ChatGPT_Image_25_sept_2026,_15_09_53.webp'
}, {
  n: '02',
  title: 'The Courtroom Testimony Prep-AI™',
  desc: 'Train with an "AI Defense Attorney" to prepare for trial.',
  price: '$30',
  cover: 'https://cdn.magicpatterns.com/uploads/9vNDkSQpJEFozRyR7Dve2h/ChatGPT_Image_25_sept_2026,_15_09_53_(1).webp'
}, {
  n: '03',
  title: 'The Supervisor’s Shift-Briefing Generator™',
  desc: 'Lead your squad with data-driven briefings in seconds.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/saJRFDmDZ49EccAH7K7w9P/ChatGPT_Image_25_sept_2026,_15_09_53_(2).webp'
}, {
  n: '04',
  title: 'The 4th Amendment AI Compliance Checklist™',
  desc: 'Instant audit of your legal justifications.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/quuWgZLfJx9wr8M8wCaAgT/ChatGPT_Image_25_sept_2026,_15_09_53_(3).webp'
}];
